import { createStore } from 'vuex'

export default createStore({
  state: {
    layout: 'default',
    isLoading: true,
    filterLoading: false
  },
  getters: {
    layout(state){
      return state.layout;
    },
    isLoading(state){
      return state.isLoading;
    },
    filterLoading(state){
      return state.filterLoading;
    }
  },
  mutations: {
    setLayout(state, layout){
      state.layout = layout;
    },
    setLoading(state, loading){
      state.isLoading = loading
    },
    setFilterLoading(state, loading){
      state.filterLoading = loading
    },
  },
  actions: {
    setLayout({commit}, layout){
      commit('setLayout', layout);
    },
    setLoading({commit}, loading){
      commit('setLoading', loading);
    },
    setFilterLoading({commit}, loading){
      commit('setFilterLoading', loading);
    },
  },
  modules: {
  }
})
